export default "__VITE_ASSET__24dec0ee__"